<template>
    <div>
    <v-card>
        <v-card-text>
                We utilize cookies to enhance the smooth operation of our application, ensuring a seamless user experience. Rest assured, your privacy remains our utmost priority. The data collected through cookies is treated with the highest level of confidentiality, our commitment to continuous improvement means we regularly update our cookie practices to align with evolving privacy standards. If you have any inquiries about our use of cookies and how it enhances your application experience while upholding your privacy. Your trust is our driving force, and we're dedicated to delivering a seamless and secure experience throughout.
            </v-card-text>
        <div style="display: flex; justify-content: space-evenly;">
            <v-btn color="primary" style="margin-bottom: 10px;" @click="cookiesCardDisplayMethod">Accept & Close</v-btn>
        <v-btn color="primary" style="margin-bottom: 10px;" @click="handleManage">learn more</v-btn>
        </div>   
        

    </v-card>
  <!-- <v-row justify="space-around"> -->
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
      v-model="manage">
          
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
              style="display: flex; justify-content: center; "
            >Cookie Usage</v-toolbar>
            <v-card-text style="text-align: justify; margin-top: 10px;">
                <ol>
                    <li><h4>Session Management</h4> We use cookies to manage your session while you are logged into our Services. These cookies are essential for the proper functioning of our website and services.</li>
                    <li><h4>Authentication</h4>Cookies are utilized to authenticate your access to our services, ensuring that only authorized users can access restricted content or perform specific actions.</li>
                    <li><h4>Routing and Navigation</h4> Cookies assist in routing pages and improving navigation within our website. They remember your preferences and help us provide a seamless browsing experience</li>
                    <li><h4>Data Retention</h4>	We retain cookies for the duration necessary to achieve their intended purpose. Session cookies are deleted when you log out or close your browser. Persistent cookies are retained for the specified duration or until you delete them.</li>
                    <li><h4>Minimal Data Collection</h4> We only collect and store essential data required for the functioning of our Services. We do not gather personally identifiable information through these cookies without your explicit consent By using our Services</li>
                </ol>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                
                @click="dialog.value = false" color="primary"
              >Close</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
  <!-- </v-row> -->
</div>
</template>

<script>
export default {
    data(){
       return{
        manage:false,
        cookiesCardDisplay:true
       } 
    },
    methods:{
        cookiesCardDisplayMethod(){
            this.$emit('hideCookies',false)
        },
handleManage(){
    this.manage=true
}
    }
    
}
</script>